module.exports = __webpack_public_path__ + "img/watch+phone_mockup.68c547c0.png";